import { useNavigate } from 'react-router';
import { Button } from '#atoms';

import { PrevHeaderBarWithTitleTemplate } from '#templates';
import { ButtonContainer, Container } from './styles';
import { useQuery } from '@tanstack/react-query';
import { axios } from '#api/axios';
import { Link } from 'react-router-dom';

type clinicalDataResponse = {
  id: number;
  title: string;
  age: number;
  sex: string;
};

export function ProfileClinicalDataPage() {
  const navigate = useNavigate();
  // const { userInfo } = useUserInfo();
  // const { mutateAsync } = useMutation(deleteClinicalData);
  // const { showToast } = useToast();

  const { data } = useQuery({
    queryKey: ['clinical-data'],
    queryFn: async () =>
      await axios.get<clinicalDataResponse[]>(`clinical-data/get/list`),
    select: data => data.data
  });

  return (
    <>
      <PrevHeaderBarWithTitleTemplate title="트레이닝 성과" defaultBackground>
        <div className="py-20 flex flex-col gap-24">
          {data &&
            data.map(value => {
              return (
                <Link
                  to={`/profile/edit/${value.id}`}
                  className="flex justify-start items-center gap-18"
                  key={value.id}
                >
                  <div className="w-90 h-90 rounded-8 bg-slate-300" />
                  <div className="flex flex-col gap-6">
                    <p className="text-[#EAE8ED] font-600">{value.title}</p>
                    <p className="text-[#8E899F] text-[14px] flex items-center gap-2">
                      <span>{value.age}세</span>
                      <span>·</span>
                      <span>{PARSE_GENDER[value.sex]}</span>
                    </p>
                  </div>
                </Link>
              );
            })}
        </div>
      </PrevHeaderBarWithTitleTemplate>
      <ButtonContainer>
        <Button onClick={() => navigate('register')}>
          트레이닝 성과 작성하기
        </Button>
      </ButtonContainer>
    </>
  );
}

const PARSE_GENDER: Record<string, string> = {
  male: '남성',
  female: '여성'
};
